<template>
  <article class="dashbord-card" @click="movePage" @mouseenter="playVideo" @mouseleave="stopVideo">
    <div class="card-art" :style="cardArtStyle">
      <!--호버시비디오플레이-->
      <video
        ref="videoRef"
        class="hover-video"
        v-if="card.videoSrc"
        :src="card.videoSrc"
        muted
        loop
        playsinline
      ></video>

      <!-- <button
        class="button-icon-text button-icon-medium button-rounded roulette-button"
        :style="{ animationDelay: `${card.animationDelay}s` }"
      >
        <component :is="iconComponent" v-if="iconComponent" />
        <span class="text-roulette">
          <span class="text-slot" :style="{ animationDelay: `${card.animationDelay}s` }">
            <span class="text-item">{{ card.buttonLabel }}</span>
            <span class="text-item">{{ card.buttonLabel }}</span>
          </span>
        </span>
      </button> -->
    </div>

    <div class="card-body">
      <div class="card-title">{{ t(card.title) }}</div>
      <div class="card-content-horizontal">
        <p>{{ t(card.subtitle) }}</p>

        <!-- <button class="button-white button-icon button-icon-medium button-rounded">
          <IconChevronRight />
        </button> -->
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useGtag } from '@/composables/shared/useGtag';
import { ISelfServiceCard } from '@/types/components';

const props = withDefaults(
  defineProps<{
    card: ISelfServiceCard;
  }>(),
  {
    card: () => ({
      title: '',
      subtitle: '',
      artBackground: '',
      buttonLabel: '',
      iconName: '',
      routeName: '',
      delay: 0,
    }),
  }
);

const { t } = useI18n();
const router = useRouter();

const { trackEventClick } = useGtag();

const videoRef = ref<HTMLVideoElement | null>(null);

// hover 재생
const playVideo = () => {
  if (videoRef.value) {
    videoRef.value.currentTime = 0;
    videoRef.value.play();
  }
};

// hover 해제
const stopVideo = () => {
  if (videoRef.value) {
    videoRef.value.pause();
    videoRef.value.currentTime = 0;
  }
};

const iconComponent = computed(() => {
  if (!props.card.iconName) return null;
  try {
    return defineAsyncComponent(() => import(`@/components/icons/${props.card.iconName}.vue`));
  } catch {
    return null;
  }
});

const cardArtStyle = computed(() => {
  const bg = props.card.artBackground;
  const style: Record<string, string> = {
    backgroundSize: 'cover',
    backgroundPosition: 'right',
    backgroundRepeat: 'no-repeat',
  };

  if (!bg) {
    style.backgroundColor = 'var(--surface-gray)';
    return style;
  }

  if (bg.startsWith('/') || /\.(png|jpg|jpeg|webp|gif|svg)$/i.test(bg)) {
    style.backgroundImage = `url(${bg})`;
  } else if (bg.startsWith('linear-gradient') || bg.startsWith('radial-gradient')) {
    style.background = bg;
  } else {
    style.backgroundColor = bg;
  }

  return style;
});

const movePage = () => {
  if (props.card.routeName) {
    trackEventClick('main', t(props.card.title, {}, { locale: 'ko' }));
    router.push({ name: props.card.routeName });
  }
};
</script>

<style scoped lang="scss">
.card-content-horizontal {
  p {
    word-break: break-all;
    color: $color-gray-900;
  }
}
.product-card {
  scroll-snap-align: start;
  min-height: 20rem;
}

.card-art {
  inline-size: 100%;
  block-size: 60%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 비디오호버
.hover-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.product-card:hover .hover-video {
  opacity: 1;
}

.button-white {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
}

.roulette-button {
  animation: buttonColor 30s infinite ease-in-out;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

.text-roulette {
  position: relative;
  height: 1.5rem;
  overflow: hidden;
  display: inline-block;
}

.text-slot {
  display: inline-flex;
  flex-direction: column;
  animation: textRoll 30s infinite ease-in-out;
}

.text-item {
  height: 1.5rem;
  line-height: 1.5rem;
  white-space: nowrap;
}

@keyframes textRoll {
  0%,
  15% {
    transform: translateY(0);
  }
  16.67%,
  98.33% {
    transform: translateY(-1.5rem);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes buttonColor {
  0%,
  15% {
    background-color: var(--surface-glass-dim);
    color: var(--font-default);
  }
  16.67%,
  98.33% {
    background-color: var(--surface-glass-dim);
    color: var(--font-default);
  }
  100% {
    background-color: var(--surface-glass-dim);
    color: var(--font-default);
  }
}

.roulette-button :deep(svg) {
  fill: currentColor;
}

@keyframes textRollWithBlur {
  0%,
  45% {
    transform: translateY(0);
    filter: blur(0);
  }
  47.5% {
    filter: blur(2px);
  }
  50%,
  95% {
    transform: translateY(-1.5rem);
    filter: blur(0);
  }
  97.5% {
    filter: blur(2px);
  }
  100% {
    transform: translateY(0);
    filter: blur(0);
  }
}
</style>
